<template>
  <div 
    class="px-5 mt-8">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-row
            class="mt-3">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.form" 
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>

                <v-card-text v-if="!process.form && Object.keys(detail).length > 0" class="px-8">
                  <div class="color-dark-blue fs-18 mb-4 font-weight-bold">
                    Detail Varian
                  </div>
                  <v-row>
                    <v-col cols="12" md="7">
                      <table style="width: auto;" class="mb-2" v-if="!process.load && Object.keys(detail).length > 0">
                        <tr>
                          <td class="fs-12">
                            Nama Produk
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ detail.product_name }}
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-12">
                            Nama Varian
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ detail.name }}
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-12">
                            Kode Varian
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ detail.sku }}
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-12">
                            Berat
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ detail.berat }}
                          </td>
                        </tr> 
                        <tr>
                          <td class="fs-12">
                            Dimensi
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ detail.dimensi }}
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-12">
                            Jumlah Dalam Dus
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ detail.total_in_dus }}
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-12">
                            Minimal Satuan
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            {{ detail.unit === '' ? '-' : detail.unit }}
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-12">
                            Harga Pricelist pcs + PPN
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            Rp {{ detail.pricelist_pcs_ppn | number_dec }}
                          </td>
                        </tr>
                        <tr v-if="detail.unit === 'Dus' && detail.total_in_dus*1 > 1">
                          <td class="fs-12">
                            Harga Pricelist Dus + PPN
                          </td>
                          <td style="width: 40px" class="fs-12 text-center pb-2">
                            : 
                          </td>
                          <td class="text-left font-weight-bold fs-12">
                            Rp {{ ((detail.pricelist_pcs_ppn*1)*(detail.total_in_dus*1) ) | number_dec }}
                          </td>
                        </tr>
                      </table>
                    </v-col>  
                    <v-col cols="12" class="pt-0">

                      <div class="mb-3">
                        <div class="fs-12">
                          
                          Deskripsi
                        </div>
                        <div
                          class="fs-12 label-input">
                          {{ detail.desc }}
                        </div>
                      </div>

                      <div 
                        class="mt-2 fs-12">
                        
                        Gambar
                      </div>
                      <v-row>
                        <v-col 
                          v-for="(item, index) in form.images"
                          :key="index"
                          cols="12" md="4">
                          <v-card 
                            flat
                            width="100%"
                            height="300"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #eaeaea; 
                                  border-style: dashed;
                                  box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; ">
                            <v-img 
                              alt="megavin" 
                              width="100%"
                              height="196"
                              :src="item"
                              contain
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>

                              <div 
                                @click="form.images.splice(index, 1)"
                                class="cursor-pointer"
                                style="position: absolute; top: 5px; right: 5px;">
                                <v-icon size="24" color="red">mdi-close-circle</v-icon>
                              </div>
                            </v-img>
                          </v-card>
                        </v-col>

                      </v-row>

                    </v-col>
                  </v-row>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <!-- <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn> -->
              
              <v-btn
                @click="$router.go(-1)"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Batal
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        form: {
          id: '',
          product_id: '',
          name: '',
          sku: '',
          images: '',
          berat: '',
          dimensi: '',
          desc: '',
          min_stock: 0,
          total_in_dus: 0,
          min_order: 0,
          dpp_jual: 0,
          biaya_lainnya_jual_1: 0,
          biaya_lainnya_jual_2: 0,
          pricelist_exclude_ppn: 0,
          pricelist_pcs_ppn: 0,
          pricelist_lusin_ppn: 0,
          pricelist_dus_ppn: 0,
          harga_beli_ppn: 0,
          ppn_beli: 0,
          dpp_beli: 0,
          harga_lainnya: 0,
          harga_pengiriman: 0,
          harga_hpp_pcs: 0,
          harga_hpp_lusin: 0,
          harga_hpp_dus: 0
        },
        detail: {},
        product: [],

        upload: {
          ttd: null,
          images: null
        },

        process: {
          form: false,

          ttd: false,

          images: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.ttd': {
        handler: function () {
          if (this.upload.ttd) {
            this.process.ttd = this.upload.ttd.process

            if (!this.process.ttd) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.ttd = this.upload.ttd.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.images': {
        handler: function () {
          if (this.upload.images) {
            this.process.images = this.upload.images.process

            if (!this.process.images) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.images = this.upload.images.fileuri
              this.form.images.push(
                this.upload.images.fileuri
              )

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        let params = {
          id: this.$route.params.id
        }

        await get('admin/varian/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
            this.form.id = res.results.data.id
            this.form.product_id = res.results.data.product_id
            this.form.name = res.results.data.name
            this.form.sku = res.results.data.sku
            this.form.images = JSON.parse(res.results.data.images)
            this.form.berat = res.results.data.berat
            this.form.dimensi = res.results.data.dimensi
            this.form.desc = res.results.data.desc
            this.form.min_stock = res.results.data.min_stock
            this.form.total_in_dus = res.results.data.total_in_dus
            this.form.min_order = res.results.data.min_order
            this.form.dpp_jual = res.results.data.dpp_jual
            this.form.biaya_lainnya_jual_1 = res.results.data.biaya_lainnya_jual_1
            this.form.biaya_lainnya_jual_2 = res.results.data.biaya_lainnya_jual_2
            this.form.pricelist_exclude_ppn = res.results.data.pricelist_exclude_ppn
            this.form.pricelist_pcs_ppn = res.results.data.pricelist_pcs_ppn
            this.form.pricelist_lusin_ppn = res.results.data.pricelist_lusin_ppn
            this.form.pricelist_dus_ppn = res.results.data.pricelist_dus_ppn
            this.form.harga_beli_ppn = res.results.data.harga_beli_ppn
            this.form.ppn_beli = res.results.data.ppn_beli
            this.form.dpp_beli = res.results.data.dpp_beli
            this.form.harga_lainnya = res.results.data.harga_lainnya
            this.form.harga_pengiriman = res.results.data.harga_pengiriman
            this.form.harga_hpp_pcs = res.results.data.harga_hpp_pcs
            this.form.harga_hpp_lusin = res.results.data.harga_hpp_lusin
            this.form.harga_hpp_dus = res.results.data.harga_hpp_dus


          }
        this.fetchProduct()
        })
      },
      async fetchProduct() {

         let params = {
          limit: 10000000000000
        }

        await get(`admin/product/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.product = res.results.data
          }
        })
      },
      change_pricelist_pcs_ppn() {
        this.form.pricelist_pcs_ppn = this.form.dpp_jual*1 + this.form.biaya_lainnya_jual_1*1 + this.form.biaya_lainnya_jual_2*1
      },
      change_dpp_beli() {
        this.form.harga_hpp_pcs = this.form.dpp_beli*1 + this.form.harga_pengiriman*1 + this.form.harga_lainnya*1
        this.form.harga_beli_ppn = this.form.dpp_beli*1 + this.form.ppn_beli*1
      },
      change_harga_beli_ppn() {
        this.form.harga_beli_ppn = this.form.dpp_beli*1 + this.form.ppn_beli*1
      },
      change_harga_hpp_pcs() {
        this.form.harga_hpp_pcs = this.form.dpp_beli*1 + this.form.harga_pengiriman*1 + this.form.harga_lainnya*1
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            ...this.form,
            images: JSON.stringify(this.form.images)
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/varian/update`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/varian' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>